import layout from "./layout.json";
import home from "./home.json";

const en = {layout, home};

export default en;
